"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionCondition = exports.PromotionSettingsType = exports.PromotionType = exports.PromotionOperator = void 0;
// #endregion
// #region Promotion criteria
var PromotionOperator;
(function (PromotionOperator) {
    PromotionOperator["AT_LEAST"] = "AT_LEAST";
    PromotionOperator["BETWEEN"] = "BETWEEN";
    PromotionOperator["EQUAL"] = "EQUAL";
})(PromotionOperator = exports.PromotionOperator || (exports.PromotionOperator = {}));
// #endregion
var PromotionType;
(function (PromotionType) {
    PromotionType["PRODUCT"] = "PRODUCT";
    PromotionType["SHIPPING"] = "SHIPPING";
})(PromotionType = exports.PromotionType || (exports.PromotionType = {}));
var PromotionSettingsType;
(function (PromotionSettingsType) {
    PromotionSettingsType["BUY_X_GET_Y"] = "BUY_X_GET_Y";
    PromotionSettingsType["FIXED_AMOUNT_DISCOUNT"] = "FIXED_AMOUNT_DISCOUNT";
    PromotionSettingsType["FIXED_PRICE_DISCOUNT"] = "FIXED_PRICE_DISCOUNT";
    PromotionSettingsType["FREE_GIVEAWAY"] = "FREE_GIVEAWAY";
    PromotionSettingsType["FREE_LOWEST_PRICE"] = "FREE_LOWEST_PRICE";
    PromotionSettingsType["FREE_SHIPPING"] = "FREE_SHIPPING";
    PromotionSettingsType["PERCENTAGE_DISCOUNT"] = "PERCENTAGE_DISCOUNT";
})(PromotionSettingsType = exports.PromotionSettingsType || (exports.PromotionSettingsType = {}));
var PromotionCondition;
(function (PromotionCondition) {
    PromotionCondition["BUY_ANY_PRODUCT"] = "BUY_ANY_PRODUCT";
    PromotionCondition["BUY_ANY_SELECTED_PRODUCT"] = "BUY_ANY_SELECTED_PRODUCT";
    PromotionCondition["BUY_X_PIECE_OF_ANY_PRODUCT"] = "BUY_X_PIECE_OF_ANY_PRODUCT";
    PromotionCondition["BUY_X_PIECE_OF_SELECTED_PRODUCT"] = "BUY_X_PIECE_OF_SELECTED_PRODUCT";
    PromotionCondition["BUY_X_PIECE_OF_SELECTED_PRODUCT_IN_BUNDLE"] = "BUY_X_PIECE_OF_SELECTED_PRODUCT_IN_BUNDLE";
    PromotionCondition["BUY_X_PRICE_IN_TOTAL_OF_ANY_PRODUCT"] = "BUY_X_PRICE_IN_TOTAL_OF_ANY_PRODUCT";
    PromotionCondition["BUY_X_PRICE_IN_TOTAL_OF_SELECTED_PRODUCT"] = "BUY_X_PRICE_IN_TOTAL_OF_SELECTED_PRODUCT";
    PromotionCondition["BUY_X_PRICE_IN_TOTAL_OF_SELECTED_PRODUCT_IN_BUNDLE"] = "BUY_X_PRICE_IN_TOTAL_OF_SELECTED_PRODUCT_IN_BUNDLE";
})(PromotionCondition = exports.PromotionCondition || (exports.PromotionCondition = {}));
//# sourceMappingURL=promotion.js.map